import FilledButton from "@/components/button/filled-button";
import { useIonRouter } from "@ionic/react";

export function ThankYouForFeedback() {
  const navigation = useIonRouter();
  return (
    <>
      <div className="flex-1 w-full flex flex-col gap-4 justify-center items-center">
        <h2 className="w-full text-center text-2xl font-semibold text-gray-900">
          Thank you for your feedback
        </h2>
        <p className="text-gray-600 text-center text-lg">
          Your answer will help us improve NutriCoach.
        </p>
      </div>
      <div className="w-full flex justify-center items-center">
        <FilledButton
          text="Go to My Plan"
          color="dark"
          expand="full"
          shape="round"
          onClick={() => navigation.push("/plans/my-plan", "none")}
        />
      </div>
    </>
  );
}
